import { createContext, useContext } from 'react';

/**
 * Lets a host page adapt shared gameplay components without forking them.
 * The account /in-play page uses the defaults (original behaviour). The guest
 * /table page hides account-only affordances and renders its own results.
 */
export interface TableOptions {
  /** Guest tables: no profile links, no Firestore chat, no coins. */
  isGuestTable: boolean;
  /**
   * Called once when the server names the Bhabi. When omitted, the original
   * leave/rematch pop-up is shown.
   */
  onGameOver?: (loser: string) => void;
}

const TableOptionsContext = createContext<TableOptions>({
  isGuestTable: false,
});

export const TableOptionsProvider = TableOptionsContext.Provider;
export const useTableOptions = () => useContext(TableOptionsContext);
